import { getAlarmProfiles } from "@src/cloud-connect/dependency-injection-container/get-alarm-profiles";
import { putAlarmProfilesUseCase } from "@src/cloud-connect/alarms/use-cases/put-alarm-profiles-use-case";

export const transferAlarmProfiles = async () => {
  const payload = getAlarmProfiles().toJSON();
  const response = await putAlarmProfilesUseCase(payload);

  return response;
};

export const transferAlarms = async () => {
  const alarmProfiles = getAlarmProfiles().getAlarmProfiles();
  if (alarmProfiles.length === 0) {
    return {
      success: true,
      data: null,
      message: "No alarm profiles to transfer",
    };
  }

  try {
    const data = await transferAlarmProfiles();

    if (!data || (data.status !== undefined && data.status !== 200)) {
      return {
        success: false,
        error: new Error("Failed to transfer alarm profiles"),
        message: "Failed to transfer alarm profiles",
      };
    }

    return { success: true, data, message: "Alarm profiles transferred" };
  } catch (error) {
    return {
      success: false,
      error,
      message: "Failed to transfer alarm profiles",
    };
  }
};
